import React, { useState } from 'react';
import BusinessModal from '../businessModal';
import LeaseModal from '../LeaseModal'
import QRCode from 'qrcode.react';
import './index.less'
function ScrollNav(props) {

  const [isModalShow, setIsModalShow] = useState(false);
  const [isShowLease, setIsShowLease] = useState(false);

  const toTopFun = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <div className="fixBox">
      <div className="box-right">
        <div className="top"></div>
        <div className="box">
          <div className="tip">
            惠租客服
          </div>
        </div>
        <div className="lease">
          <div className="pic"></div>
          <div className="font">我要租赁</div>
          <div className='box-lease-all' >
            <div className="box-lease">
              <div className="title">星企租</div>
              {/* <div className="pic"></div> */}
              <QRCode
                id='ceshi1'
                className={'pic'}
                size={230}
                imageSettings={{
                  // 二维码中间的logo图片
                  src: 'https://oss.huizustore.com/679f52e3b8594280826d2a81085988ac.png',
                  height: 55,
                  width: 55,
                  excavate: true, // 中间图片所在的位置是否镂空
                }}
                level='M'
                value={`alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/home/index`}
              />
              <div className="tip">企业租赁 支付宝扫一扫</div>
            </div>
            <div className="box-lease">
              <div className="title">惠租</div>
              {/* <div className="pic"></div> */}
              <QRCode
                id='ceshi2'
                className={'pic'}
                size={230}
                imageSettings={{
                  // 二维码中间的logo图片
                  src: 'https://oss.huizustore.com/bcaba4058531430fa71b30ae527490a7.png',
                  height: 55,
                  width: 55,
                  excavate: true, // 中间图片所在的位置是否镂空
                }}
                level='M'
                value={`alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/home/index`}
              />
              <div className="tip">个人租赁 支付宝扫一扫</div>
            </div>
            <div className="box-lease">
              <div className="title">公众号</div>
              <div className="pic1"></div>
              <div className="tip">微信扫一扫 关注我们</div>
            </div>
          </div>

        </div>
        <div className='switch'>
        </div>
        <div className="wechat">
          <div className="pic"></div>
          <div className="font">微信咨询</div>
          <div className="box-wechat">
            <div className="title">微信咨询</div>
            <div className="tip">0成本快速开启你的租赁店铺</div>
            <div className="pic"></div>
            <div className="content">微信扫一扫，立即咨询开店</div>
          </div>
        </div>
        <div className="phone">
          <div className="pic"></div>
          <div className="font">电话咨询</div>
          <div className="box-phone">
            <div className="box-phone-title">客服热线</div>
            <div className="box-phone-phone">0571—26881669</div>
            <div className="box-phone-time">9:30-18:00</div>
          </div>
        </div>
        <div className="bus" onClick={() => setIsModalShow(true)} >
          <div className="pic"></div>
          <div className="font">商家入驻</div>
        </div>
        <div className="bus" onClick={() => setIsShowLease(true)} >
          <div className="pic1"></div>
          <div className="font">企业定制</div>
        </div>
        {/* <div className="bus1" onClick={() => toTopFun()} >
          <div className="pic"></div>
          <div className="font">顶部</div>
        </div> */}
      </div>
      {isModalShow && (
        <BusinessModal visible={isModalShow} handleCancel={() => setIsModalShow(false)} />
      )}
      {isShowLease && (
        <LeaseModal
          isShowLease={isShowLease}
          canceLease={() => setIsShowLease(false)}
        />
      )}
    </div>
  )
}

export default ScrollNav;